import React, {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {MsalPca} from "@modules/msal.ts";
import {MainProviders} from "./MainProviders.tsx";
import {Analytics} from '@vercel/analytics/react'
import {SpeedInsights} from '@vercel/speed-insights/react'

const msalInstance = MsalPca
await msalInstance.initialize()

document.addEventListener('keydown', function (event) {
    if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
    }
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Analytics/>
        <SpeedInsights/>
        <MainProviders msalInstance={msalInstance}/>
    </StrictMode>,
)

